"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
// THIS FILES IS GENERATED USING SCRIPT, DO NOT EDIT DIRECTLY
var theme = {
    borderRadius: {
        0: '0',
        1: '1px',
        2: '2px',
        4: '4px',
        6: '6px',
        8: '8px',
        12: '12px',
        16: '16px',
        none: '0',
        sm: '0.125rem',
        md: '0.375rem',
        lg: '0.5rem',
        "default": '1px',
        full: '100%'
    },
    borderWidth: { 0: '0', 1: '1px', 2: '2px', 4: '4px', 6: '6px', 8: '8px', 12: '12px', 16: '16px', "default": '1px' },
    fontFamily: {
        sans: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
        serif: 'Georgia, Cambria, "Times New Roman", Times, serif',
        mono: 'Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace'
    },
    fontWeight: {
        300: '300',
        400: '400',
        500: '500',
        600: '600',
        700: '700',
        hairline: '100',
        thin: '200',
        light: '300',
        normal: '400',
        regular: '400',
        medium: '500',
        semibold: '600',
        bold: '700',
        extrabold: '800',
        black: '900'
    },
    inset: { 0: '0', auto: 'auto' },
    letterSpacing: {
        tighter: '-0.05em',
        tight: '-0.025em',
        normal: '0',
        wide: '0.025em',
        wider: '0.05em',
        widest: '0.1em'
    },
    lineHeight: {
        3: '.75rem',
        4: '1rem',
        5: '1.25rem',
        6: '1.5rem',
        7: '1.75rem',
        8: '2rem',
        9: '2.25rem',
        10: '2.5rem',
        none: '1',
        tight: '1.25',
        snug: '1.375',
        normal: '1.5',
        relaxed: '1.625',
        loose: '2'
    },
    margin: {
        0: '0',
        1: '0.4rem',
        2: '0.8rem',
        3: '1.2rem',
        4: '1.6rem',
        5: '2rem',
        6: '2.4rem',
        7: '2.8rem',
        8: '3.2rem',
        9: '3.6rem',
        10: '4rem',
        11: '4.4rem',
        12: '4.8rem',
        15: '-0.6rem',
        16: '6.4rem',
        20: '8rem',
        24: '9.6rem',
        32: '12.8rem',
        40: '16rem',
        48: '19.2rem',
        56: '22.4rem',
        64: '25.6rem',
        auto: 'auto',
        '05': '-0.2rem',
        px: '-1px',
        '-1': '-0.4rem',
        '-2': '-0.8rem',
        '-3': '-1.2rem',
        '-4': '-1.6rem',
        '-5': '-2rem',
        '-6': '-2.4rem',
        '-7': '-2.8rem',
        '-8': '-3.2rem',
        '-9': '-3.6rem',
        '-10': '-4rem',
        '-11': '-4.4rem',
        '-12': '-4.8rem',
        '-16': '-6.4rem',
        '-20': '-8rem',
        '-24': '-9.6rem',
        '-32': '-12.8rem',
        '-40': '-16rem',
        '-48': '-19.2rem',
        '-56': '-22.4rem',
        '-64': '-25.6rem'
    },
    maxHeight: { full: '100%', screen: '100vh' },
    maxWidth: {
        none: 'none',
        xs: '20rem',
        sm: '24rem',
        md: '28rem',
        lg: '32rem',
        xl: '36rem',
        '2Xl': '42rem',
        '3Xl': '48rem',
        '4Xl': '56rem',
        '5Xl': '64rem',
        '6Xl': '72rem',
        full: '100%',
        screenSm: '640px',
        screenMd: '768px',
        screenLg: '1024px',
        screenXl: '1280px'
    },
    minHeight: { 0: '0', full: '100%', screen: '100vh' },
    minWidth: { 0: '0', full: '100%' },
    outlineOffset: { 0: '0px', 1: '1px', 2: '2px', '-2': '-2px', '-1': '-1px' },
    outlineWidth: { 1: '1px', 2: '2px' },
    outlineStyle: {
        none: 'none',
        solid: 'solid',
        dashed: 'dashed',
        dotted: 'dotted',
        double: 'double',
        hidden: 'hidden'
    },
    padding: {
        0: '0',
        1: '0.4rem',
        2: '0.8rem',
        3: '1.2rem',
        4: '1.6rem',
        5: '2rem',
        6: '2.4rem',
        7: '2.8rem',
        8: '3.2rem',
        9: '3.6rem',
        10: '4rem',
        11: '4.4rem',
        12: '4.8rem',
        15: '0.6rem',
        16: '6.4rem',
        20: '8rem',
        24: '9.6rem',
        32: '12.8rem',
        40: '16rem',
        48: '19.2rem',
        56: '22.4rem',
        64: '25.6rem',
        '05': '0.2rem',
        px: '1px'
    },
    stroke: { current: 'currentColor' },
    gap: {
        0: '0',
        1: '0.4rem',
        2: '0.8rem',
        3: '1.2rem',
        4: '1.6rem',
        5: '2rem',
        6: '2.4rem',
        7: '2.8rem',
        8: '3.2rem',
        9: '3.6rem',
        10: '4rem',
        11: '4.4rem',
        12: '4.8rem',
        16: '6.4rem',
        20: '8rem',
        24: '9.6rem',
        32: '12.8rem',
        40: '16rem',
        48: '19.2rem',
        56: '22.4rem',
        64: '25.6rem',
        px: '1px'
    },
    translate: {
        0: '0',
        1: '0.4rem',
        2: '0.8rem',
        3: '1.2rem',
        4: '1.6rem',
        5: '2rem',
        6: '2.4rem',
        7: '2.8rem',
        8: '3.2rem',
        9: '3.6rem',
        10: '4rem',
        11: '4.4rem',
        12: '50%',
        16: '6.4rem',
        20: '8rem',
        24: '9.6rem',
        32: '12.8rem',
        40: '16rem',
        48: '19.2rem',
        56: '22.4rem',
        64: '25.6rem',
        px: '-1px',
        '-1': '-0.4rem',
        '-2': '-0.8rem',
        '-3': '-1.2rem',
        '-4': '-1.6rem',
        '-5': '-2rem',
        '-6': '-2.4rem',
        '-7': '-2.8rem',
        '-8': '-3.2rem',
        '-9': '-3.6rem',
        '-10': '-4rem',
        '-11': '-4.4rem',
        '-12': '-4.8rem',
        '-16': '-6.4rem',
        '-20': '-8rem',
        '-24': '-9.6rem',
        '-32': '-12.8rem',
        '-40': '-16rem',
        '-48': '-19.2rem',
        '-56': '-22.4rem',
        '-64': '-25.6rem',
        full: '100%'
    },
    transitionTimingFunction: {
        linear: 'linear',
        "in": 'cubic-bezier(0.4, 0, 1, 1)',
        out: 'cubic-bezier(0, 0, 0.2, 1)',
        inOut: 'cubic-bezier(0.4, 0, 0.2, 1)'
    },
    borderColor: { transparent: 'transparent', current: 'currentColor' },
    borderOpacity: {
        0: '0',
        5: '0.05',
        10: '0.1',
        15: '0.15',
        20: '0.2',
        25: '0.25',
        30: '0.3',
        40: '0.4',
        50: '0.5',
        60: '0.6',
        70: '0.7',
        75: '0.75',
        80: '0.8',
        90: '0.9',
        100: '1'
    },
    placeholderColor: { transparent: 'transparent', current: 'currentColor' },
    placeholderOpacity: {
        0: '0',
        5: '0.05',
        10: '0.1',
        15: '0.15',
        20: '0.2',
        25: '0.25',
        30: '0.3',
        40: '0.4',
        50: '0.5',
        60: '0.6',
        70: '0.7',
        75: '0.75',
        80: '0.8',
        90: '0.9',
        100: '1'
    },
    screens: { sm: '640px', md: '768px', lg: '1024px', xl: '1280px' },
    textColor: { transparent: 'transparent', current: 'currentColor' },
    fontSize: {
        10: '1rem',
        11: '1.1rem',
        12: '1.2rem',
        13: '1.3rem',
        14: '1.4rem',
        16: '1.6rem',
        20: '2rem',
        24: '2.4rem',
        32: '3.2rem',
        40: '4rem',
        56: '5.6rem',
        72: '7.2rem'
    }
};
exports["default"] = __assign({}, theme);
